<template>
  <div class="hello">

      <!-- Modal to show no subject error -->
        <b-modal no-fade id='modal-nosubject' title="Missing Email Subject" ok-only header-bg-variant='info' header-text-variant="light">
            Please enter a subject for this email
        </b-modal>


    <b-container>
        <!-- Select counties -->
        <b-row style="margin-top:10px">
            <b-col>
                <h3>Select counties to send email to (up to 10)</h3>
            </b-col>
        </b-row>

        <!-- Send email -->
        <b-row style="margin-bottom:5px">
            <b-col>
                <b-button :disabled="selectedCounties.length<=0" size="lg" variant="info" block style="margin-top:20px" @click="goToComponseEmail()">Go To Compose Email</b-button>
            </b-col>
        </b-row>

        <!-- Check min counties -->
        <b-row  v-if="selectedCounties.length<=0">
            <b-col style="color:red">
                Select at least one county
            </b-col>
        </b-row>

        <div v-for="(county, index) in getCounties" :key="county.name">
            <div v-if="county.isSelected" style="margin-bottom:5px">
                <b-button :pressed="true" variant="warning" @click="removeCountyFromList(county.name)">{{county.name}} <font-awesome-icon icon="times" /></b-button>
            </div>
            <div v-else style="margin-bottom:5px">
                <b-button variant="success" @click="addToCountyList(county.name, index)">{{county.name}} </b-button>
            </div>
        </div>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')

export default {    
    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser']),

        getCounties(){
            this.allCounties=[]
            var arraySize = this.userProfile.counties.length
            for (var i = 0; i<arraySize; i++){
                var theCounty = {}
                theCounty.name = this.userProfile.counties[i]
                var existingCountyindex = -1
                if(this.selectedCounties.length>0 ) existingCountyindex = this.selectedCounties.findIndex(item => item === theCounty.name);
                if (existingCountyindex > -1){
                    theCounty.isSelected = true
                } 
                else theCounty.isSelected = false
                this.allCounties.push(theCounty)
            }
            return this.allCounties
        },
    },

    components: {
    },

    data() {
        return {
            emailHTML:"",
            buyersList:[],
            emailSubject:'',
            allCounties:[],
            selectedCounties:[],
            maxCountiesLength:10,

        }
    },

    methods:{

        addToCountyList(countyName, index){
                if(this.selectedCounties.length<this.maxCountiesLength) this.selectedCounties.push(countyName)

        },
        removeCountyFromList(countyName){
            var existingCountyindex = this.selectedCounties.findIndex(item => item === countyName);
            if (existingCountyindex > -1){
                this.selectedCounties.splice(existingCountyindex,1)
                }
        },
        goToComponseEmail(){
            //Save counties to store
            //this.$store.commit('setSelectedCountiesForEmail',this.selectedCounties)
            this.$store.commit('setCountiesForEmail',this.selectedCounties)
            this.$router.push({ path: 'composeemail'})

        },

    },

    mounted(){
    },
}
</script>


